const fieldLibrary = {
  title: "Библиотека полей",
  fields: "Поля",
  templates: "Шаблоны",
  styles: "Стили",
  search: "Поиск полей...",
  noResults: "Поля не найдены",
  expandPanel: "Развернуть панель",
  categoryText: "Текст",
  categorySelection: "Выбор",
  categoryTime: "Время",
  configTitle: "Настройки поля",
  label: "Метка",
  placeholder: "Подсказка",
  required: "Обязательное",
  maxLength: "Макс. длина",
  defaultValue: "Значение по умолчанию",
  defaultChecked: "Отмечено по умолчанию",
  options: "Варианты",
  addOption: "Добавить вариант",
  maxSelections: "Макс. выбор",
  format: "Формат",
  allowCustomTags: "Разрешить пользовательские теги",
  maxTags: "Макс. тегов",
  addTag: "Добавить тег",
  save: "Сохранить",
  cancel: "Отмена",
  saving: "Сохранение...",
  soon: "Скоро",
  existingFields: "Существующие поля",
  createNew: "Новое поле",
  usageCount: "Использований",
  usedIn: "Используется в:",
  noDefinitions: "Полей пока нет. Создайте поле на вкладке «Новое поле».",
  insertField: "Вставить поле",
  editDefinition: "Редактировать определение",
  deleteDefinition: "Удалить поле",
  confirmDelete: "Вы уверены? Это поле используется в {count} документах.",
  lastEdited: "Последнее редактирование",
  dropdownMode: "Выпадающий список",
  floatingMode: "Плавающее окно",
  loading: "⏳ Загрузка...",
} as const;
export default fieldLibrary;
